import React, { useEffect } from 'react'
import { FeedbackMessage } from 'components/marketplace/FeedbackMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Typography } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { useDeprecatedBrokerCarrierAgreementsQuery } from './DeprecatedBrokerCarrierAgreements'
import { PackageFilesDeletedRow } from './PackageFilesDeletedRow'
import { PackageFilesRow } from './PackageFilesRow'

interface IPackageFilesProps {
  getUploadedDocs: (...args: any[]) => any
  carrierId: number
  documents: {
    fileUrl: string
    fileName: string
    _destroy: string
  }[]
  error: string
  loading: boolean
  dialogOpen: boolean
  deleteDocUpload: (...args: any[]) => any
  uploadDocument: (...args: any[]) => any
}

const PackageFiles: React.FunctionComponent<IPackageFilesProps> = React.memo(
  ({ carrierId, documents, error, getUploadedDocs, loading }) => {
    const isShowDeprecatedBcasEnabled = useFeatureFlag('showDeprecatedBcas')

    useEffect(() => {
      if (carrierId) {
        getUploadedDocs(carrierId)
      }
    }, [carrierId])
    const {
      data: bcaData,
      error: bcaError,
      loading: bcaLoading,
    } = useDeprecatedBrokerCarrierAgreementsQuery({
      variables: {
        id: `${carrierId}`,
      },
      skip: !carrierId,
    })
    const { carrierApplication } = bcaData || {}
    const { deprecatedBrokerCarrierAgreements } = carrierApplication || {}
    const isLoading = loading || bcaLoading
    const errors = error || bcaError?.message
    const showDeletedBcas =
      isShowDeprecatedBcasEnabled &&
      !!deprecatedBrokerCarrierAgreements &&
      !!deprecatedBrokerCarrierAgreements.length
    return (
      <div>
        <Typography className='mb2' variant='subtitle2'>
          Uploads
        </Typography>

        {isLoading && <Spinner />}
        {errors && <FeedbackMessage message={errors} type='error' />}
        {documents &&
          !error &&
          documents
            .filter(({ _destroy }) => !_destroy)
            .map(document => <PackageFilesRow key={document.fileUrl} document={document} />)}
        {showDeletedBcas && (
          <Typography className='mt4 mb2' variant='subtitle2'>
            Deleted BCAs
          </Typography>
        )}
        {showDeletedBcas &&
          !bcaError &&
          deprecatedBrokerCarrierAgreements.map(bca => (
            <PackageFilesDeletedRow
              key={bca.file.url}
              url={bca.file.url}
              fileName={bca.file.name}
              deprecatedAt={bca.deprecatedAt}
            />
          ))}
      </div>
    )
  }
)

export default PackageFiles
